<template>
  <p class="mensagem">Problemas de conexão com o servidor</p>
</template>

<script>
export default {
  name: 'ErroConexao',
}

</script>

<style lang="scss" scoped>

.mensagem {
  font-size: 0.9rem;
  color: white;
}

</style>
